<template>
  <div>
    <div class="accordion">
      <div class="accordion__body">
        <div class="accordion__form" style="max-width: 1180px;">
          <div class="accordion__part">
            <div class="accordion__name">
              <span>Employment information</span>
            </div>
            <div class="accordion__row accordion__row--5">
              <app-form-group label="Role">
                <app-select
                  v-model="role"
                  :options="role_options"
                  placeholder="Role"
                />
              </app-form-group>
              <app-form-group label="Guarantor">
                <app-select
                  v-model="guarantor_crew"
                  :options="guarantor_options"
                  label="full_name"
                  placeholder="Guarantor"
                />
              </app-form-group>
            </div>
          </div>
          <div class="accordion__part">
            <div class="accordion__name">
              <span>Payment details</span>
            </div>
            <div class="accordion__row accordion__row--5">
              <app-form-group label="Account number" label-for="account_number">
                <app-input
                  v-model="position.bank_account"
                  id="account_number"
                  placeholder="0"
                  name="account_number"
                />
              </app-form-group>
            </div>
            <app-cells :indent="false" position="end">
              <app-button @click.native="onSendForm" ref="submit_personal">
                Save
              </app-button>
            </app-cells>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getClimbingMountainCrewListSearch, getClimbingMountainCrewRole, patchClimbingMountainCrew } from '@/http'

export default {
  name: 'ClimbingMountainCrewPosition',
  props: {
    position: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      role_options: [],
      guarantor_options: [],
      role: null,
      guarantor_crew: null,
    }
  },
  created() {
    getClimbingMountainCrewRole().then(res => { this.role_options = res.data })
    getClimbingMountainCrewListSearch({ role: 'guide' }).then(res => { this.guarantor_options = res.data })
    this.guarantor_crew = this.position.guarantor_crew
    this.role = this.position.role
  },
  methods: {
    onSendForm() {
      this.$refs.submit_personal.preload = true
      patchClimbingMountainCrew(this.$route.params.id, this.normalizePersonal())
        .finally(() => { this.$refs.submit_personal.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Data saved successfully',
          })
        })
    },
    normalizePersonal() {
      const normalizedForm = {}

      if (this.role && typeof this.role !== 'string') {
        normalizedForm.role = this.role.code
      }
      if (this.guarantor_crew && typeof this.guarantor_crew !== 'number') {
        normalizedForm.guarantor_crew = this.guarantor_crew.id
      }

      return normalizedForm
    },
  }
}
</script>
